import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { supabase } from '../lib/supabaseClient';

const Footer = ({ isDarkMode }) => {
  const [user, setUser] = useState(null);

  useEffect(() => {
    let mounted = true;
    (async () => {
      try {
        const { data } = await supabase.auth.getSession();
        if (mounted) setUser(data?.session?.user || null);
      } catch (error) {
        // Handle error silently
      }
    })();
    
    const { data: sub } = supabase.auth.onAuthStateChange((_event, session) => {
      setUser(session?.user || null);
    });
    
    return () => {
      sub.subscription?.unsubscribe?.();
      mounted = false;
    };
  }, []);

  const handleBugReportClick = (e) => {
    e.preventDefault();
    window.dispatchEvent(new CustomEvent('openBugReport'));
  };

  const handleFeedbackClick = (e) => {
    e.preventDefault();
    window.dispatchEvent(new CustomEvent('openFeedbackForm'));
  };

  return (
    <footer className={`${isDarkMode ? 'bg-gray-800' : 'bg-gray-100'} py-4 border-t ${isDarkMode ? 'border-gray-700' : 'border-gray-200'}`}>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {/* Navigation Column */}
          <div>
            <h3 className={`text-sm font-bold ${isDarkMode ? 'text-gray-200' : 'text-gray-900'} uppercase mb-2`}>Navigation</h3>
            <nav className="space-y-1">
              <Link to="/bills" className={`block text-sm ${isDarkMode ? 'text-gray-400 hover:text-gray-200' : 'text-gray-600 hover:text-gray-900'} transition-colors`}>
                Bills
              </Link>
              <Link to="/calendar" className={`block text-sm ${isDarkMode ? 'text-gray-400 hover:text-gray-200' : 'text-gray-600 hover:text-gray-900'} transition-colors`}>
                Calendar
              </Link>
              <Link 
                to={user ? "/account" : "/signin"} 
                className={`block text-sm ${isDarkMode ? 'text-gray-400 hover:text-gray-200' : 'text-gray-600 hover:text-gray-900'} transition-colors`}
              >
                Account
              </Link>
            </nav>
          </div>
          
          {/* About Column */}
          <div>
            <h3 className={`text-sm font-bold ${isDarkMode ? 'text-gray-200' : 'text-gray-900'} uppercase mb-2`}>About</h3>
            <nav className="space-y-1">
              <Link to="/about" className={`block text-sm ${isDarkMode ? 'text-gray-400 hover:text-gray-200' : 'text-gray-600 hover:text-gray-900'} transition-colors`}>
                About
              </Link>
              <button 
                onClick={handleBugReportClick}
                className={`block text-sm ${isDarkMode ? 'text-gray-400 hover:text-gray-200' : 'text-gray-600 hover:text-gray-900'} transition-colors text-left`}
              >
                Report a Bug
              </button>
              <button 
                onClick={handleFeedbackClick}
                className={`block text-sm ${isDarkMode ? 'text-gray-400 hover:text-gray-200' : 'text-gray-600 hover:text-gray-900'} transition-colors text-left`}
              >
                Request Feedback
              </button>
            </nav>
          </div>

          {/* Contact Column */}
          <div>
            <h3 className={`text-sm font-bold ${isDarkMode ? 'text-gray-200' : 'text-gray-900'} uppercase mb-2`}>Contact</h3>
            <a 
              href="mailto:founders@civicduty.app" 
              className={`block text-sm ${isDarkMode ? 'text-gray-400 hover:text-gray-200' : 'text-gray-600 hover:text-gray-900'} transition-colors`}
            >
              founders@civicduty.app
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
